module.exports = __webpack_public_path__ + "img/footer-infocenter.54a1bef8.png";